export const getGifUrl = (filename: string) => {
  return `${filename}?${Math.random()}`;
};
